<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title"> Сохраненные настройки спецификаций</div>
                <div class="tools">

                    <button type="button" class="btn btn-primary btn-sm" [disabled]="!checkedCheckBox()"
                        (click)="deleteSelected()">
                        <i class="bi bi bi-trash"></i> {{ 'DELETE_SELECTED' | translate }}
                    </button>

                    <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()">
                        <i class="bi bi-plus-circle"></i> {{ 'CREATE' | translate }}
                    </button>

                </div>
            </div>

            <div class="card-body">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_all_spec"
                                        id="select_all_spec" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_all_spec"></label>
                                </div>
                            </th>
                            <th scope="col" class="name"> Наименование спецификации</th>
                            <th scope="col" class="author"> Автор</th>
                            <th scope="col" class="change_date"> Дата создания</th>
                            <!-- <th scope="col" class="download_count"> Редактировал(а)</th>
                            <th scope="col" class="last_download"> Последнее изменение</th> -->
                            <!-- <th scope="col" class="upload_products"> Выгружено товаров <i class="bi bi-arrow-down-up"></i></th> -->
                            <th scope="col" class="action"> Действие</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="specifications.length > 0">
                        <tr *ngFor="let specification of specifications; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="specification{{ i }}"
                                        id="specification{{ i }}"  [checked]="specification.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="specification{{ i }}"></label>
                                </div>
                            </td>
                            <td class="name">{{ specification.name.ru }}</td>
                            <td class="author">{{ specification.user_create }}</td>
                            <td class="change_date">{{ specification.created_at | date: 'dd.MM.yyyy HH:mm' }}</td>
                            <!-- <td class="editor">{{ specification.user_change }}</td>
                            <td class="last_change_date">{{ specification.last_change }}</td> -->
                            <td class="action">
                                <button type="button" class="btn btn-light mr-1" routerLink="/specifications/edit/{{specification.id }}" placement="top" ngbTooltip="{{ 'EDIT' | translate }}">
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                                <button type="button" class="btn btn-light" (click)="onConfirm(specification.id, 'single')" placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i> 
                                </button>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="!specifications || specifications.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="8">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="8">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>

    </div>
</div>